import React from 'react';
import { XIcon } from 'lucide-react';
import { notNeeded } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function NoStartFromZero() {
  return <section className="bg-paper" data-id="element-178" data-mp="1lemwgm1qt8z2">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28" data-id="element-179" data-mp="1ldla3lfa1021">
        <SectionHeading eyebrow="Sin reformas ni gastos" title={<>
              Transformar tu hogar <span className="text-clay" data-id="element-181" data-mp="1bp3dzhhxzh4q">no significa empezar de cero</span>
            </>} data-id="element-180" data-mp="1qdhh7tj9t7lt" />

        <ul className="mx-auto mt-12 grid max-w-4xl gap-x-10 gap-y-5 sm:mt-14 sm:grid-cols-3 sm:gap-y-6" data-id="element-182" data-mp="1gfjrf1lrj2r3">
          {notNeeded.map(item => <li key={item} className="flex items-start gap-3" data-id="element-183" data-mp="12oy7d9kkomrm">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-clay-tint" aria-hidden="true" data-id="element-184" data-mp="16pqg81pj8pnd">
                <XIcon className="h-3.5 w-3.5 text-clay" strokeWidth={2.5} data-id="element-185" data-mp="spphoswqpub2" />
              </span>
              <span className="text-[14.5px] leading-snug text-ink-soft sm:text-[15px]" data-id="element-186" data-mp="xpbtcxwx72hr">{item}</span>
            </li>)}
        </ul>

        <p className="mx-auto mt-14 max-w-2xl rounded-2xl bg-sage-tint px-6 py-7 text-center font-display text-[19px] font-semibold leading-[1.45] text-ink sm:mt-16 sm:px-10 sm:text-[24px]" data-id="element-187" data-mp="3kj5ozaw9sc01">
          Solo necesitás aprender a observar tu espacio{' '}
          <span className="text-clay" data-id="element-188" data-mp="3olsj5igey90e">con una nueva mirada.</span>
        </p>
      </div>
    </section>;
}